module.exports = __webpack_public_path__ + "static/media/ellipsis-h.30fc3bdc.svg";